import { combineReducers } from 'redux';

import { GET_TEMPLATE_SUCCESS, GET_TEMPLATES_SUCCESS } from '../../actionTypes';

function byId(state = {}, action) {
    if (!action) return state;

    switch (action.type) {
        case GET_TEMPLATES_SUCCESS:
            const nextState = {};
            action.templates.forEach((tmp) => (nextState[tmp.id] = tmp));
            return nextState;

        case GET_TEMPLATE_SUCCESS: {
            const nextState = { ...state };
            const { id, ...rest } = action.payload;
            nextState[id] = { ...nextState[id], ...rest };
            return nextState;
        }

        default:
            return state;
    }
}

export default combineReducers({ byId });

export const getTemplates = (state) => Object.values(state.byId);
export const getTemplate = (state, id) => state.byId[id];
